function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//

import * as React from 'react';
import Pill from "./Pill";
import { color } from "../../styles/theme";
import { PILL_TYPE, PILL_SIZE } from "./Pill";
var STATUS_COLORS = {
  error: color.danger,
  warning: color.warning,
  success: color.success,
  info: color.info,
  "default": color.lightGrayText
};
export default function StatusPill(_ref) {
  var htmlAttributes = _ref.htmlAttributes,
    label = _ref.label,
    rootClassName = _ref.rootClassName,
    size = _ref.size,
    status = _ref.status,
    styleAlt = _ref.style,
    tag = _ref.tag,
    type = _ref.type;
  var filled = type === PILL_TYPE.FILLED;
  var style = filled ? _objectSpread(_objectSpread({}, styleAlt), {}, {
    color: color.white,
    fontWeight: 'bold'
  }) : styleAlt;
  return /*#__PURE__*/React.createElement(Pill, {
    size: size,
    type: type,
    borderColor: STATUS_COLORS[status],
    fillColor: filled ? STATUS_COLORS[status] : undefined,
    label: label,
    tag: tag,
    rootClassName: rootClassName,
    style: style,
    htmlAttributes: htmlAttributes
  });
}
StatusPill.defaultProps = {
  size: PILL_SIZE.MD,
  type: PILL_TYPE.OUTLINE,
  status: 'default',
  tag: 'span'
};